import appSlice, { appState } from "../stores/appSlice";
import { useAppSelector } from "../stores/hooks";

export const getPropByString = (obj: any, propString: string) => {
  if (!propString) return obj;

  var prop,
    props = propString.split(".");

  for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
    prop = props[i];

    var candidate = obj[prop];
    if (candidate !== undefined) {
      obj = candidate;
    } else {
      break;
    }
  }
  return obj[props[i]];
};
